import { ComponentMap } from '@cinch-nx/data-storyblok'
import { NextImage, RichText, IconWithText, CtaButton } from '../atom-blocks'
import { FinanceRepresentativeExample } from '@cinch-nx/ui-finance'

export const atomStoryblokComponents: ComponentMap = {
  CtaButton,
  FinanceRepresentativeExample,
  Image_v2: NextImage,
  RichText,
  IconWithText,
}
